import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { useErrors } from '../../../../hooks/errors/use-errors';
import { useHttpClient } from '../../../../utils/clients/rest-client';
import {
  OptimizerSetConfigData,
  OptimizerSetConfigError,
  OptimizerSetModeData,
  OptimizerSetModeError,
  OptimizerSetTestModeLoadData,
  OptimizerSetTestModeLoadError,
  SetOptimizerConfigRequest,
  SetOptimizerModeRequest,
  SetOptimizerTestModeLoadRequest,
} from '../../types/openapi/openapi-types';

export const useOptimizerSetMode = () => {
  const { t } = useTranslation('backend-validation');
  const httpClient = useHttpClient();
  const { handleRestErrors } = useErrors();

  return useMutation<AxiosResponse<OptimizerSetModeData>, AxiosError<OptimizerSetModeError>, SetOptimizerModeRequest>(
    ['optimizer-setMode'],
    async (body) => await httpClient.optimizer.optimizerSetMode(body),
    {
      onError: (error) => {
        handleRestErrors(error, t((error.response?.data as OptimizerSetModeError).errorCode));
      },
    },
  );
};

export const useOptimizerSetTestModeLoad = () => {
  const httpClient = useHttpClient();
  const { t } = useTranslation('backend-validation');
  const { handleRestErrors } = useErrors();

  return useMutation<
    AxiosResponse<OptimizerSetTestModeLoadData>,
    AxiosError<OptimizerSetTestModeLoadError>,
    SetOptimizerTestModeLoadRequest
  >(['optimizer-setTestModeLoad'], async (body) => await httpClient.optimizer.optimizerSetTestModeLoad(body), {
    onError: (error) => {
      handleRestErrors(error, t((error.response?.data as OptimizerSetTestModeLoadError).errorCode));
    },
  });
};

export const useOptimizerSetConfig = () => {
  const httpClient = useHttpClient();

  return useMutation<
    AxiosResponse<OptimizerSetConfigData>,
    AxiosError<OptimizerSetConfigError>,
    SetOptimizerConfigRequest
  >(['optimizer-setConfig'], async (body) => await httpClient.optimizer.optimizerSetConfig(body), {});
};
